import { createAuth } from "@websanova/vue-auth/src/v3.js";
import driverAuthBearer from "@websanova/vue-auth/src/drivers/auth/bearer.js";
import driverHttpAxios from "@websanova/vue-auth/src/drivers/http/axios.1.x.js";
import driverRouterVueRouter from "@websanova/vue-auth/src/drivers/router/vue-router.2.x.js";
import { useAuthStore } from "@/stores";

const httpDriver = {
  ...driverHttpAxios,
    invalidToken(res) {
      if (!res || res.status !== 401) {
        return false;
      }

      const path = (window.location.pathname || "/").replace(/\/+$/, "") || "/";
      if (path === "/pre-login" || path === "/login") {
        return false;
      }

      const url = res.config?.url || "";

      return /\/api\/auth\/user(?:\?|$)|\/auth\/refresh(?:\?|$)/.test(url);
    },
};

let authInstance = null;

export function getAuthInstance() {
  return authInstance;
}

export default (app) => {
  const authStore = useAuthStore();

  authInstance = createAuth({
    plugins: {
      http: app.axios,
      router: app.router,
    },
    drivers: {
      http: httpDriver,
      auth: driverAuthBearer,
      router: driverRouterVueRouter,
    },
    options: {
      staySignedIn: false,
      rolesKey: "type",
      tokenStore: ["localStorage", "cookie"],
      authRedirect: { path: "/login" },
      loginData: {
        url: "/auth/login",
        method: "POST",
        redirect: "/",
        headerToken: "Authorization",
        fetchUser: true,
        customToken: (response) => response.data.access_token,
      },
      fetchData: {
        url: "/api/auth/user",
        method: "get",
        interval: 10,
        enabled: false,
      },
      refreshData: {
        url: "/api/auth/refresh",
        method: "GET",
        enabled: false,
      },
      logoutData: {
        url: "/api/auth/logout",
        method: "POST",
        redirect: "/logout",
      },
      parseUserData(data) {
        authStore.$patch({
          user: data,
        });

        return data;
      },
    },
  });

  app.use(authInstance);
};
